import { Search } from 'lucide-react'
import type { KeyboardEvent } from 'react'

/** Search field for a page header or a filter bar. */
export function SearchInput({ value, onChange, placeholder, label, width = 'w-[320px]', onKeyDown }: {
  value: string
  onChange: (v: string) => void
  /** e.g. Enter opens the first result */
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void
  placeholder: string
  /** accessible name */
  label: string
  width?: string
}) {
  return (
    <label className={`relative flex min-w-0 items-center ${width}`}>
      <Search aria-hidden className="pointer-events-none absolute left-2.5 size-3.5 text-text-3" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        aria-label={label}
        className="h-8 w-full rounded-md border border-input bg-surface pl-8 pr-2.5 text-[13px] text-foreground placeholder:text-text-3"
      />
    </label>
  )
}

/** Skeleton rows while a table loads. */
export function LoadingRows({ label, rows = 8 }: { label: string; rows?: number }) {
  return (
    <div role="status" className="space-y-2 px-4 py-3" aria-busy="true" aria-label={label}>
      {Array.from({ length: rows }).map((_, i) => <div key={i} className="skeleton h-[22px] w-full" />)}
    </div>
  )
}
